import React from 'react';
import AppBaseComponent from '../../../components/AppBaseComponent';
import ApplicationLayout from "../../../layouts/ApplicationLayout";
import { connect } from "react-redux";
import Ax from "../../../components/hoc/Ax";
import moment from "moment";
import tapIcon from "../../../services/TapIcon";
import HttpAPICall from "../../../services/HttpAPICall";
import Loader from "../../../components/ui/Loader/Loader";
import { Collapse } from 'bootstrap';
import { DisplayListPagination, DisplaySearchCriteria } from "../../../components/TapUi/index";
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import DatePicker from "react-datepicker";
import DownloadFile from "../../../services/DownloadFile";
import InputItemSearch from '../../includes/ui/InputItemSearch';
import InputAssetSearch from '../../includes/ui/InputAssetSearch';
import TapSelect from "../../../components/ui/TapSelect";
import Helmet from 'react-helmet';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import RunningStatusViewModal from '../../assets/action/serviceChecksheet/runningStatus/RunningStatusViewModal';
import LinkedItemsViewModal from '../../assets/action/serviceChecksheet/runningStatus/LinkedItemsViewModal';
import { Modal } from 'bootstrap';
import axios from 'axios';
import ErrorValidation from '../../../services/ErrorValidation';
import ItemDetailsModal from '../../items/itemDetails/ItemDetailsModal';
import ItemsConsumptionHistory from '../../inventory/consumption/ItemsConsumptionHistory';
import CounterlogExecutionModal from '../../assets/counterlog/CounterlogExecutionModal';
import api from '../../../services/api';
import InputUserSearch from '../../includes/ui/InputUserSearch';

class ServiceChecksheetRunningStatus extends AppBaseComponent {

    constructor(props) {
        super(props);
        let today                                     =   new Date()
        this.cancelToken        = null;
        this.reportUrl          = IAM_API_BASE_URL_2 + '/report/service_checksheet_running_status';
        this.formDataUrl        =   IAM_API_BASE_URL_2 + '/report/asset-status/form_data';
       


        this.reportFilterFormInitialState = {
            search_item_tags                    :   [],
            search_item_ids                     :   [],
            'asset_group_ids'                   :   [],
            search_asset_type_ids               :   [],
            search_asset_ids                    :   [],
            site_group_ids                      :   [],
            search_site_ids                     :   [],
            search_name                         :   '',
            search_scs_running_status           :   [],
            search_date_from                    :   '',
            search_date_to                      :   '',
            search_asset_category               :   'Y',
            search_meter_types                  :   [],
            search_user_asset                   :   '',
        };

        this.reportFilterFormLabel          =   {
            search_item_tags                :   'Item Tags : ',
            search_item_ids                 :   'Items : ',
            'asset_group_ids'               :   'Asset Type Groups : ',
            search_asset_type_ids           :   'Asset Type : ',
            search_asset_ids                :   'Assets : ',
            search_site_ids                 :   'Sites : ',
            site_group_ids                  :   'Site Group : ',
            search_name                     :   'Service Checksheet Name : ',
            search_scs_running_status       :   'Status : ',
            search_date_from                :   'Due Date  :  ',
            search_asset_category           :   'Asset Category : ',
            search_meter_types              :   'Meter Types : ',
            search_user_asset               :   'User Asset : ',
        };

        this.executeFormInit = {
            odometer                        :       '',
            hourmeter                       :       '',
            hourmeter2                      :       '',
            hourmeter3                      :       '',
            hourmeter4                      :       '',
            date_time                       :       '',
            odometer2                       :       '',
            odometer3                       :       '',
            operation_cycle                 :       '',
            operation_cycle2                :       '',
        }

        this.state = {
            formDataLoaded                  : false,
            reportDownloadBtn               : false,
            reportDownloading               : false,
            reportFilterForm                : { ...this.reportFilterFormInitialState },
            submittedReportFilterForm       : { ...this.reportFilterFormInitialState },
            listing_loading                 : false,
            searchedItem                    : [],
            listingData                     : [],
            listingMeta                     : null,
            allItemTags                     : [],
            manufactures                    : [],
            allStatusOptions                : [],
            searchedAssets                  : [],
            iam_asset_types                 : [],
            iam_user_sites                  : [],
            Show_list                       :   false,
            linked_items                    : [],
            selectedAssetForExecution       : [],
            execution_loading               : false,
            asset_loading                   : false,
            executeForm                     : { ...this.executeFormInit },
            executeFormSubmitting           : false,
            totalListingCount               : 0,
            time                            : '',
            allSiteGroupsList               : [],
            allAssetTypesGroupsList         : [],
            parameterOptions                : [{ value: 'ok', label: 'Checked and OK' },
            { value: 'required_attention', label: 'May Required Attention' },
            { value: 'required_immediateattention', label: 'Required Immediate Attention' }],
            reportData                      : null,
            iam_asset_category              : [],
            criteriaHeight                  :   0,
            allMeter                        :   [], 
            selectedMeters                  :   [],
            meterValues                     :   {},
            searchedUser                    :   null
        };
        this.criteriaRef                    = React.createRef();
        this.RunningStatusModalRef          = React.createRef();
        this.LinkedItemsViewModalRef        = React.createRef();
        this.itemDetailsRef                 = React.createRef();
        this.itemsConsumptionHistoryRef     = React.createRef();
        this.counterlogExecutionRef         = React.createRef();
    }

    componentDidMount = () => {
        
        this.initPageComponent(this.props);
       
    }

      updateCriteriaHeight = () => {
        if (this.criteriaRef.current) {
            const height = this.criteriaRef.current.offsetHeight;
            if (this.state.criteriaHeight !== height) {
                this.setState({ criteriaHeight: height });
            }
        }
    };
    componentDidUpdate(prevProps, prevState) {
        if (prevState.formSearchedElems !== this.state.formSearchedElems) {
            this.updateCriteriaHeight();
        }
    }
    componentWillReceiveProps = (nextProps) => {
        if (this.props.iam_user_sites != nextProps.iam_user_sites) {
            this.initPageComponent(nextProps);
        }
    }
    handleUrlFilters = () => {
        const urlParams = new URLSearchParams(this.props.location.search);

        const filters = {
            search_site_ids: urlParams.get('type') == "total_scs" ? urlParams.get('site_id').split(',') : [urlParams.get('site_id')],
        };
        this.setState({
            reportFilterForm: {
                ...this.state.reportFilterForm,
                ...filters,
            },
        }, () => {
            this.reportFilterFormSubmit();
        });
    }
    initPageComponent = (pr) => {
    const report_name = 'service_checksheet_running_status';
    const reportData = pr?.report_listing.length > 0 ? pr.report_listing.filter(d => d.key === report_name) : [];
    this.setState({
        reportData: reportData.length > 0 ? reportData[0] : null,
    });

    // Initialize Data
    let Status = [{ value: 'over_due', label: 'OverDue' }, { value: 'due_soon', label: 'Due-Soon' }, { value: 'in_limit', label: 'Within Limits' }];
    
    this.setState({
        access_token: pr.access_token,
        Show_list         :   true,
        iam_asset_types: pr.iam_asset_types ? pr.iam_asset_types.map((at) => { return { value: at.id, label: at.asset_type_name } }) : [],
        iam_user_sites: pr.iam_user_sites ? pr.iam_user_sites.map((s) => { return { value: s.id, label: `${s.site_name} (${s.site_code})` } }) : [],
        allItemTags: pr.item_tags && pr.item_tags.length > 0 ? pr.item_tags.map((s) => { return { value: s.id, label: s.name }; }) : [],
        allStatusOptions: Status,
        allSiteGroupsList: pr.site_groups && pr.site_groups.length > 0 ? pr.site_groups.map(oc => { return ({ value: oc.id, label: oc.name, linked_sites: oc.site_ids }) }) : [],
        allAssetTypesGroupsList: pr.asset_groups && pr.asset_groups.length > 0 ? pr.asset_groups.map(oc => { return ({ value: oc.id, label: oc.name, linked_asset_types: oc.asset_type_ids }) }) : [],
    }, () => {
        let search_scs_running_status = ['over_due', 'due_soon', 'in_limit'];
        let ParamObject = new URLSearchParams(this.props.location.search);
        let search_site_ids = [];
        let search_asset_type_ids = [];
        let search_asset_ids = [];
        let assetName = [];
        
        let selectedMeters = [];
        let meterValues = {};
        
        const escaltionScsMinHr = ParamObject.get('escaltion_scs_min_hr');
        const escaltionScsMaxHr = ParamObject.get('escaltion_scs_max_hr');
        
        if (escaltionScsMinHr || escaltionScsMaxHr) {
            selectedMeters.push('hours');
            let hourValue = '';
            
            if (escaltionScsMinHr && escaltionScsMaxHr) {
                hourValue = `${escaltionScsMinHr}-${escaltionScsMaxHr}`;
            } else if (escaltionScsMinHr) {
                hourValue = `${escaltionScsMinHr}-0`;
            } else if (escaltionScsMaxHr) {
                hourValue = `0-${escaltionScsMaxHr}`;
            }
            
            meterValues['hours'] = { 
                value: hourValue, 
                label: 'Hours' 
            };
        }
        
        const escaltionScsMinKm = ParamObject.get('escaltion_scs_min_km');
        const escaltionScsMaxKm = ParamObject.get('escaltion_scs_max_km');
        
        if (escaltionScsMinKm || escaltionScsMaxKm) {
            selectedMeters.push('kilometer');
            let kmValue = '';
            
            if (escaltionScsMinKm && escaltionScsMaxKm) {
                kmValue = `${escaltionScsMinKm}-${escaltionScsMaxKm}`;
            } else if (escaltionScsMinKm) {
                kmValue = `${escaltionScsMinKm}-0`;
            } else if (escaltionScsMaxKm) {
                kmValue = `0-${escaltionScsMaxKm}`;
            }
            
            meterValues['kilometer'] = { 
                value: kmValue, 
                label: 'Kilometer' 
            };
        }

        if (ParamObject.get('scs_status')) {
            search_scs_running_status = ParamObject.get('scs_status');
        }
        if (ParamObject.get('search_site_ids')) {
            let site = this.state.iam_user_sites.find(us => us.value == ParamObject.get('search_site_ids'));
            if (site) {
                search_site_ids = [site.value];
            }
        }
        if (ParamObject.get('search_asset_type_ids')) {
            let assetType = this.state.iam_asset_types.find(us => us.value == ParamObject.get('search_asset_type_ids'));
            if (assetType) {
                search_asset_type_ids = [assetType.value];
            }
        }
        if (ParamObject.get('search_asset_ids')) {
            let assetId = ParamObject.get('search_asset_ids');
            let asset_name = ParamObject.get('asset_name');
            if (assetId) {
                search_asset_ids = [assetId];
                assetName = [{ label: asset_name, display_label: asset_name }]
            }
        }
        const params = new URLSearchParams(this.props.location.search);
        const searchAssetCategory = params.get('search_asset_category');
        
        this.setState({
            reportFilterForm: {
                ...this.state.reportFilterForm,
                search_scs_running_status: search_scs_running_status,
                search_site_ids: search_site_ids,
                search_asset_type_ids: search_asset_type_ids,
                search_asset_ids: search_asset_ids,
                search_asset_category: searchAssetCategory ? searchAssetCategory : "Y",
                search_meter_types: selectedMeters
            },
            searchedAssets: assetName,
            selectedMeters: selectedMeters,
            meterValues: meterValues
        }, () => {
            this.filterFormDataInit();
        });
    });
}
    filterFormDataInit = () => {
    let ParamObject = new URLSearchParams(this.props.location.search);

    HttpAPICall.withAthorization('GET', this.formDataUrl, this.props.access_token, null, null, (response) => {
        let respData = response.data;
        
        const allMeterOptions = respData.all_meter.map(d => ({label: d.value, value: d.key}));
        
        const hoursMeter = allMeterOptions.find(m => m.label.toLowerCase().includes('hour'));
        const kmMeter = allMeterOptions.find(m => m.label.toLowerCase().includes('kilometer') || m.label.toLowerCase().includes('km'));
        
        let updatedSelectedMeters = [...this.state.selectedMeters];
        let updatedMeterValues = {...this.state.meterValues};
        
        if (this.state.selectedMeters.includes('hours') && hoursMeter) {
            updatedSelectedMeters = updatedSelectedMeters.filter(m => m !== 'hours');
            updatedSelectedMeters.push(hoursMeter.value);
            
            if (updatedMeterValues['hours']) {
                updatedMeterValues[hoursMeter.value] = {
                    ...updatedMeterValues['hours'],
                    label: hoursMeter.label
                };
                delete updatedMeterValues['hours'];
            }
        }
        
        if (this.state.selectedMeters.includes('kilometer') && kmMeter) {
            updatedSelectedMeters = updatedSelectedMeters.filter(m => m !== 'kilometer');
            updatedSelectedMeters.push(kmMeter.value);
            
            if (updatedMeterValues['kilometer']) {
                updatedMeterValues[kmMeter.value] = {
                    ...updatedMeterValues['kilometer'],
                    label: kmMeter.label
                };
                delete updatedMeterValues['kilometer'];
            }
        }

        this.setState({
            formDataLoaded: true,
            iam_asset_category: respData.asset_category.map(ac => { return { value: ac.key, label: ac.name } }),
            allMeter: allMeterOptions,
            selectedMeters: updatedSelectedMeters,
            meterValues: updatedMeterValues,
            reportFilterForm: {
                ...this.state.reportFilterForm,
                search_meter_types: updatedSelectedMeters
            }
        });

        if (ParamObject.get('site_id')) {
            this.handleUrlFilters();
        }
        else if (ParamObject.get('scs_status') || ParamObject.get('search_site_ids') || ParamObject.get('search_asset_type_ids') || ParamObject.get('search_asset_ids') || ParamObject.get('asset_name')) {
            this.reportFilterFormSubmit();
        } else {
            this.reportFilterhandler();
        }
    }, (err) => { });
}
    closeReport = () => {
        this.props.history.push('/report');
    }
    handleMeterSelect = (selectedOptions) => {
        const selectedMeters = selectedOptions.map(option => option.value);
        const meterValues = { ...this.state.meterValues };

        selectedOptions.forEach(option => {
            const meter = option.value;
            if (!meterValues[meter]) {
                meterValues[meter] = { value: '', label: option.label }; 
            }
        });

        this.setState({ selectedMeters, meterValues,
            reportFilterForm: {
            ...this.state.reportFilterForm,
            search_meter_types: selectedMeters 
        }
         });
    };


    reportFilterFormSubmit                  =   (event=null)  =>  {
        event && event.preventDefault();
        let serachFormKeys = Object.keys(this.state.reportFilterForm);
        let searchedElems = [];
        let itemSearchParams = {};
        const formatArrayForDisplay = (array, maxVisible = 3) => {
            if (!array || array.length === 0) return '';
            if (array.length <= maxVisible) {
                return array.join(', ');
            }
            const visibleItems = array.slice(0, maxVisible).join(', ');
            return `${visibleItems} +${array.length - maxVisible} more`;
        };
        serachFormKeys.map((key) => {
            let label = this.reportFilterFormLabel[key];
            let value = this.state.reportFilterForm[key];
            if (value && value.toString().length > 0) {
                itemSearchParams[key] = value;
                if (label) {
                    let show_val = value;

                    if (key == 'search_item_ids') {
                        show_val = this.state.searchedItem ? this.state.searchedItem.map(s => s.display_label).join(', ') : '';
                    }

                    if (key == 'search_item_tags') {
                        show_val = this.state.allItemTags.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }

                    if (key == 'search_asset_ids') {
                        show_val = this.state.searchedAssets ? this.state.searchedAssets.map(s => s.display_label).join(', ') : '';
                    }
                    if (key == 'asset_group_ids') {
                        show_val = this.state.allAssetTypesGroupsList.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if (key == 'search_asset_type_ids') {
                        show_val = this.state.iam_asset_types.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if (key == 'site_group_ids') {
                        show_val = this.state.allSiteGroupsList.filter((s) => value.includes(s.value)).map(s => s.label).join(', ')
                    }
                    // if (key == 'search_site_ids') {
                    //     show_val = this.state.iam_user_sites.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    // }
                    if (key == 'search_site_ids') {
                        const sites = this.state.iam_user_sites
                            .filter((s) => value.includes(s.value))
                            .map(s => s.label);
                        show_val = formatArrayForDisplay(sites, 3);
                    }
                    if (key == 'search_scs_running_status') {
                        show_val = this.state.allStatusOptions.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if (key == 'search_meter_types') {
                        show_val = this.state.allMeter.filter((s) => value.includes(s.value)).map(s => s.label).join(', ')
                    }
                    if (key == 'search_name') {
                        show_val = this.state.reportFilterForm.search_name;
                    }
                    if (key == 'search_asset_category') {
                        show_val = this.state.iam_asset_category.filter((s) => value.includes(s.value)).map(s => s.label);
                    }
                    if (key == 'search_date_from') {
                        let start_range = this.state.reportFilterForm.search_date_from ? moment(this.state.reportFilterForm.search_date_from).format('DD-MMM-YYYY') : '';
                        let end_range = this.state.reportFilterForm.search_date_to ? moment(this.state.reportFilterForm.search_date_to).format('DD-MMM-YYYY') : ''
                        let display_date = `(${start_range} - ${end_range})`
                        show_val = display_date;
                    }
                    if (key == "search_user_asset") {
                        show_val            =   this.state.searchedUser ? this.state.searchedUser.label : "";
                    }

                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        Object.keys(this.state.meterValues).forEach(meter => {
            if (this.state.meterValues[meter]?.value) {
                let meterLabel = this.state.meterValues[meter]?.label || meter;
                searchedElems.push(`Meter ${meterLabel} : <b>${this.state.meterValues[meter].value}</b>`);
            }
        });


        this.setState({
            submittedReportFilterForm: { ...this.state.reportFilterForm, search_meter_types: this.state.selectedMeters },
            formSearchedElems: searchedElems
        }, () => {
            this.loadListingTblData(1);
        });
    }

    loadListingTblData                      = (page = 1, reload = false) => {
        this.setState({
            listing_loading: true,
             Show_list                   :   true,
            listingData: [],
            listingMeta: null,
            reportDownloadBtn: false,
            reportDownloading: false
        });

        let submittedFilterForm = {
            ...this.state.submittedReportFilterForm,
            search_date_from: this.state.submittedReportFilterForm.search_date_from ? moment(this.state.submittedReportFilterForm.search_date_from).format('YYYY-MM-DD') : '',
            search_date_to: this.state.submittedReportFilterForm.search_date_to ? moment(this.state.submittedReportFilterForm.search_date_to).format('YYYY-MM-DD') : '',
            search_meter_types: this.state.selectedMeters
        }
        Object.keys(this.state.meterValues).forEach(meter => {
            if (this.state.meterValues[meter]?.value) {
                const meterKey = `${meter}_running`;
                submittedFilterForm[meterKey] = this.state.meterValues[meter].value;
            }
        });

        let params = { page: page, get_asset_profile: "Y", ...submittedFilterForm, reload: reload ? 'reload' : false, };
        Object.keys(params).forEach(key => {
            if (params[key] === '' || params[key] === null || params[key] === undefined ||
                (Array.isArray(params[key]) && params[key].length === 0)) {
                delete params[key];
            }
        });


        if (this.cancelToken) {
            this.cancelToken.cancel("Operation canceled due to new request.")
        }
        this.cancelToken = axios.CancelToken.source();
         api.server2Api({
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + this.props.access_token },
            params: params,
            url: this.reportUrl,
            cancelToken: this.cancelToken.token
        }).then((response) => {
            let respData = response.data.data;

            this.setState({
                listingData: respData.data,
                reportDownloadBtn: true,
                listingMeta: {
                    from: respData.from,
                    to: respData.to,
                    total: respData.total,
                    last_page: respData.last_page,
                    per_page: respData.per_page,
                    current_page: respData.current_page
                },
                totalListingCount: respData.total,
                time: response.data.time ? response.data.time : ''
            }, () => {
                this.setState({ listing_loading: false ,
                      Show_list :false
                });
            });
            if (respData) {
                let all_scs_ids = respData.data.map((scs, key) => scs.id);
                if (respData.data && respData.data.length > 0) {
                    this.getAllLinkedItemsList(all_scs_ids)
                }
            }
        }).catch((err) => {
            if (axios.isCancel(err)) {
            } else {
                ErrorValidation.apiErrorHandle(err, 'Unable to Get / Save Application Data.');
            }
        }).then(() => {
            // this.setState({listing_loading: false});
        });
    }

    refreshSingleSCSRow = (id) => {
        if (!id) return;
         let submittedFilterForm = {
            ...this.state.submittedReportFilterForm,
            search_date_from: this.state.submittedReportFilterForm.search_date_from ? moment(this.state.submittedReportFilterForm.search_date_from).format('YYYY-MM-DD') : '',
            search_date_to: this.state.submittedReportFilterForm.search_date_to ? moment(this.state.submittedReportFilterForm.search_date_to).format('YYYY-MM-DD') : '',
        }

        let params = { page: 1, get_asset_profile: "Y", ...submittedFilterForm,  search_scs_setting_ids: id};
        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/report/service_checksheet_running_status', this.props.access_token, { ...params }, {})
       .then((response) => {
            const updatedRow = response.data?.data?.data?.[0];
            if (!updatedRow) return;
            let listingData = [...this.state.listingData];
            const index = listingData.findIndex(row => row.id === id);
            if (index > -1) {
                listingData[index] = updatedRow;
                this.setState({ listingData }, () => {
                    this.getAllLinkedItemsList([id]); // Refresh linked items for this row
                });
            }
        }).catch((err) => {
            ErrorValidation.apiErrorHandle(err, 'Unable to refresh the updated row.');
        });
    }


    getAllLinkedItemsList                   = (all_ids) => {
        let params = { scs_setting_ids: all_ids };
        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/scs/asset/item_linked_scs_setting', this.props.access_token, params, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                linked_items: respData.data,
            })
        })
    }

    linkAssetHandler                        = (id) => {
        this.props.history.push('/asset/dashboard/' + id)
    } 

    reportDownloadHandler                   = () => {
        this.setState({ reportDownloading: true });
        let submittedFilterForm = {
            ...this.state.submittedReportFilterForm,
            search_date_from: moment(this.state.submittedReportFilterForm.search_date_from).format('YYYY-MM-DD'),
            search_date_to: moment(this.state.submittedReportFilterForm.search_date_to).format('YYYY-MM-DD'),
              search_meter_types: this.state.selectedMeters
        }
        Object.keys(this.state.meterValues).forEach(meter => {
            if (this.state.meterValues[meter]?.value) {
                const meterKey = `${meter}_running`;
                submittedFilterForm[meterKey] = this.state.meterValues[meter].value;
            }
        });
        HttpAPICall.withAthorization('GET', this.reportUrl, this.props.access_token, { ...submittedFilterForm, download: 'download' }, {}, (response) => DownloadFile.file(null, response.data.msg, response.data.navigation, this.props)).then(() => this.setState({ reportDownloading: false }));
    }

    reportFilterhandler                     = () => {
        new Collapse(document.getElementById('reportFilterForm'));
        if (document.getElementById('pageTbl')) {
            document.getElementById('pageTbl').scroll({ top: 0, behavior: 'smooth' });
        }
    }

    runningStatusModalInit                  = (id) => {
        let scsRunningData = this.state.listingData.find(sc => sc.id == id)
        if (scsRunningData) {
            this.RunningStatusModalRef.current.runningStatusModalInit(scsRunningData);
        }

    }

    tapDateChange                           =       (selectedOption)        =>  {
        
        if (selectedOption && selectedOption.length > 0) {
            this.setState({
                reportFilterForm: {
                    ...this.state.reportFilterForm,
                    search_date_from    :       selectedOption[0] ? selectedOption[0] : '',
                    search_date_to      :       selectedOption[1] ? selectedOption[1] : '',
                }
            });
        }
    }

    viewLinkedItemInit                      = (id, name) => {
        let linkedItemData = this.state.linked_items.find(sc => sc.scs_setting_id == id)
        if (linkedItemData) {
            this.LinkedItemsViewModalRef.current.linkedItemsModalInit(linkedItemData, name);
        }
    }

    getAsssetDetails                        = (selected) => {
        this.setState({ asset_loading: true });
        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/asset/' + selected.asset_id, this.props.access_token, {}, {}, (response) => {
            this.setState({ assetDetail: response.data.data }, () => {
                this.setState({ selectedAssetForExecution: [selected], execution_loading: false }, () => {
                    if (this.counterlogExecutionRef.current) {
                        this.counterlogExecutionRef.current.executeCounterlogInit(
                            [selected],
                            this.state.assetDetail,
                            selected?.counterlog || null,
                            false,
                            IAM_API_BASE_URL_2 + '/scs/execute_with_reading'
                        );
                    }
                });
            });
        }, (error) => {
            toast.error(error?.msg, { position: toast.POSITION.TOP_RIGHT });
        }).then(() => { this.setState({ asset_loading: false }) })
    }

    executeSingleModalInit = (id) => {
        this.setState({ execution_loading: true });

        let selected = this.state.listingData.find(scs => scs.id === id);
        if (!selected) return;

        this.getAsssetDetails(selected);
       
    }


    // executeSingleModalInit                  = (id) => {
    //     this.setState({ execution_loading: true, selectedAssetForExecution: [] })
    //     let selectedAssetForExecution = [];
    //     let newList = this.state.listingData.find(scs => scs.id == id);

    //     selectedAssetForExecution.push(newList)
    //     this.getAsssetDetails(newList.asset_id)
    //     this.executeCounterlogModal.show()
    //     this.setState({ selectedAssetForExecution: selectedAssetForExecution, execution_loading: false })

    // }

    submitExecuteFormHandler                = (e) => {
        e.preventDefault();

        let scs_setting_ids = this.state.selectedAssetForExecution.map((s, k) => s.id)

        let parameter = [];
        parameter = this.state.selectedAssetForExecution.filter(s => s.enable_parameter == "Y");

        let executeForm = { ...this.state.executeForm }
        let frmData = {
            scs_setting_ids: scs_setting_ids,
            ...executeForm,
            parameter: parameter.length > 0
                ? parameter.map((p, key) => {
                    if (p.execute_level) {
                        return ({ scs_setting_id: p.id, execute_level: p.execute_level ? parseInt(p.execute_level) : null })
                    } else {
                        return ({ scs_setting_id: p.id, execute_val: p.execute_val ? p.execute_val : null })
                    }
                })
                : []
        };
        this.setState({ executeFormSubmitting: true })
        HttpAPICall.withAthorization('POST', IAM_API_BASE_URL_2 + '/scs/execute_with_reading', this.props.access_token, {}, { ...frmData }, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            this.executeCounterlogModal.hide()
            this.loadListingTblData(1, true)
            this.setState({ executeForm: { ...this.executeFormInit } })
        }).then(() => this.setState({ executeFormSubmitting: false }));
    }

    

    viewItemModalInit                       = (item, linkedQty) => {
        if (item) {
            this.itemDetailsRef.current.modalInit(item, linkedQty, true)
        }
    }

    viewItemConumptionHistoryInit           = (id ,asset_id) => {
        let item_ids = []
        if (this.state.linked_items && this.state.linked_items.length > 0) {
            item_ids = this.state.linked_items.filter(li => li.scs_setting_id == id).map((item, index) => {
                return (item.items?.length > 0 ? item.items.map((i, itemKey) => { return (i.item_id) }) : [])
            })
            this.itemsConsumptionHistoryRef.current.modalInit(item_ids.flat(), asset_id)
        }
    }

    pageTitleBarJsx                         = () => {
        return (<div className="page_title row m0">
            <div className="col-sm-12">
                <h3><tapIcon.FontAwesomeIcon icon={tapIcon.faCubes} /> Service CheckSheet Running Status </h3>
                <div className='text-end mt15'>
                    {this.state.reportDownloadBtn ? (<button disabled={this.state.reportDownloading || this.state.reportData?.download_access === 'N'} type="button" onClick={this.reportDownloadHandler} className="btn btn-primary"><tapIcon.FontAwesomeIcon icon={tapIcon.faDownload} /> Download Detailed Report {this.state.reportDownloading ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}</button>) : null}
                    <button type="button" onClick={this.reportFilterhandler} className="btn btn-secondary">Change Filter</button>
                    <button disabled={this.state.listing_loading || this.state.reportDownloading} type="button" onClick={() => this.loadListingTblData(1, true)} className="btn btn-secondary"><tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} />{this.state.reportDownloading ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}</button>
                    <button type="button" disabled={this.state.listing_loading || this.state.reportDownloading} className="btn btn-secondary mx-1" onClick={this.closeReport}>
                        <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="Close requisition" />
                    </button>
                </div>
            </div>

        </div>);
    }

    reportFilterFormJsx                     = () => {
        return (<div id="reportFilterForm" className="bg-white collapse " aria-expanded="true">
            <form onSubmit={this.reportFilterFormSubmit} className={['p-3', 'filter_form'].join(' ')}>

                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Service Checksheet Name/Alias Name</label>
                    <div className="col-sm-6">
                        <input
                            name="search_name"
                            type="text"
                            value={this.state.reportFilterForm.search_name}
                            onChange={(e) => this.formInputHandler(e, 'reportFilterForm')}
                            className="form-control"
                            autoComplete="off"
                            placeholder="Service Checksheet Name / Alias Name"
                        />
                    </div>
                </div>
                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Asset Name</label>
                    <div className="col-sm-6">
                        <InputAssetSearch
                            changeEvent={(selectedOption) => {
                                this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_asset_ids');
                                this.setState({ searchedAssets: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                            }}
                            isMulti={true}
                            value={this.state.searchedAssets.length > 0 ? this.state.searchedAssets.map(a => { a.label = a.display_label; return a; }) : []}
                        />
                    </div>
                </div>
                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Asset Type Group</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={this.state.allAssetTypesGroupsList}
                            changeEvent={(selectedOption) => {

                                this.setState({
                                    reportFilterForm: {
                                        ...this.state.reportFilterForm,
                                        asset_group_ids: selectedOption && selectedOption.length > 0 ? selectedOption.map(o => o.value) : [],
                                        search_asset_type_ids: selectedOption && selectedOption.length > 0 ? selectedOption.map(s => s.linked_asset_types).flat() : []
                                    }
                                })
                            }}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={this.state.allAssetTypesGroupsList.filter(s => this.state.reportFilterForm.asset_group_ids.includes(s.value))}
                            placeholder="Select Asset Type Group"
                        />
                    </div>
                </div>
                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Asset Type</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={this.state.iam_asset_types}
                            changeEvent={(selectedOption) => {
                                this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_asset_type_ids');
                            }}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={this.state.iam_asset_types.filter(s => this.state.reportFilterForm.search_asset_type_ids.includes(s.value))}
                            placeholder="Select Asset Type"
                        />
                    </div>
                </div>
                 <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Asset Category</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={this.state.iam_asset_category}
                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_asset_category')}
                            value={this.state.iam_asset_category.find(r => r.value ===  this.state.reportFilterForm.search_asset_category  )}
                            placeholder="ALL"
                            menuPlacement="top"
                        />
                    </div>
                </div>

                <div className="row mb-3">
                    <label className="col-sm-3 col-form-label text-end">User Asset</label>
                    <div className="col-sm-6">
                        <InputUserSearch
                        changeEvent={(selectedOption) => {
                            this.tapSelectChange(
                            selectedOption,
                            "reportFilterForm",
                            "search_user_asset"
                            );
                            this.setState({
                            searchedUser: selectedOption ? selectedOption : null,
                            });
                        }}
                        value={
                            this.state.searchedUser
                            ? {
                                ...this.state.searchedUser,
                                label: this.state.searchedUser.label,
                            }
                            : null
                        }
                        />
                    </div>
                </div>

                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Site Group</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={this.state.allSiteGroupsList}
                            changeEvent={(selectedOption) => {
                                this.setState({
                                    reportFilterForm: {
                                        ...this.state.reportFilterForm,
                                        site_group_ids: selectedOption && selectedOption.length > 0 ? selectedOption.map(o => o.value) : [],
                                        search_site_ids: selectedOption && selectedOption.length > 0 ? selectedOption.map(s => s.linked_sites).flat() : []
                                    }
                                })
                            }}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            menuPlacement="bottom"
                            value={this.state.allSiteGroupsList.filter(s => this.state.reportFilterForm.site_group_ids.includes(s.value))}
                            placeholder="Select Site Group"
                        />
                    </div>
                </div>
                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Site Name</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={this.state.iam_user_sites}
                            changeEvent={(selectedOption) => {
                                this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_site_ids');
                            }}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            menuPlacement="bottom"
                            value={this.state.iam_user_sites.filter(s => this.state.reportFilterForm.search_site_ids.includes(s.value))}
                            placeholder="Select Sites"
                        />
                    </div>
                </div>

                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Item</label>
                    <div className="col-sm-6">
                        <InputItemSearch
                            placeholder="Search Item"
                            isMulti={true}
                            changeEvent={(selectedOption) => {
                                this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_item_ids');
                                this.setState({
                                    searchedItem: selectedOption ? selectedOption : null
                                }, () => { });
                            }}
                            value={this.state.searchedItem.length > 0 ? this.state.searchedItem.map(a => { a.label = a.display_label; return a; }) : []}
                        />
                    </div>
                </div>
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Item Tags</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={this.state.allItemTags}
                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_item_tags')}
                            value={this.state.allItemTags.filter(u => this.state.reportFilterForm?.search_item_tags?.includes(u.value))}
                            isSearchable={true}
                            isMulti={true}
                            isClearable={true}
                            menuPlacement="top"
                            placeholder="Select Item Tags"
                        />
                    </div>
                </div>
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Status</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={this.state.allStatusOptions}
                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_scs_running_status')}
                            value={this.state.allStatusOptions.filter(u => this.state.reportFilterForm?.search_scs_running_status?.includes(u.value))}
                            isSearchable={true}
                            isMulti={true}
                            isClearable={true}
                            menuPlacement="top"
                            placeholder="Select Status"
                        />
                    </div>
                </div>
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Meter Type</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={this.state.allMeter} 
                            changeEvent={this.handleMeterSelect}
                            isMulti={true}
                            value={this.state.allMeter.filter(m => this.state.selectedMeters.includes(m.value))}
                            isSearchable={true}
                            isClearable={true}
                            menuPlacement="top"
                            placeholder="Select Meter Type"
                        />
                    </div>
                </div>

                {this.state.selectedMeters.map((meter) => (
                    <div className="row align-items-center" key={meter}>
                        <label className="col-sm-3 col-form-label text-end">
                            {this.state.meterValues[meter]?.label || meter}
                        </label>
                        <div className="col-sm-6">
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder={`Range for ${this.state.meterValues[meter]?.label || meter} (e.g., 0-100 or 50-200)`}
                                    value={this.state.meterValues[meter]?.value || ''}
                                    onChange={(e) => this.setState({
                                        meterValues: {
                                            ...this.state.meterValues,
                                            [meter]: {
                                                ...this.state.meterValues[meter],
                                                value: e.target.value
                                            }
                                        }
                                    })}
                                />
                            </div>
                            <br />
                        </div>
                    </div>
                ))}


                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Select Due Date</label>
                    <div className="col-sm-6 add_calender_section">
                        <DatePicker
                            selectsRange={true}
                            monthsShown={2}
                            dateFormat="dd-MMM-yyyy"
                            className={'form-control'}
                            startDate={this.state.reportFilterForm.search_date_from}
                            endDate={this.state.reportFilterForm.search_date_to}
                            name="date"
                            autoComplete="off"
                            onChange={(value, event) => {
                                this.tapDateChange(value)
                            }}
                        />
                        <tapIcon.imageIcon icon={tapIcon.CalenderIcon} className="add_calender-icon" />
                    </div>
                </div>

                <div className="row">
                    <div className="pb-3 col-9 text-end">
                        <button type="submit" disabled={this.state.listing_loading ? true : false} className="btn btn-primary px-4" onClick={this.reportFilterhandler}>Show Report</button>
                    </div>
                    <hr />
                </div>
            </form>
        </div>);
    }

    reportListingDisplayJsx                 = () => {
        return (<div className="bg-white">
              { this.state.listing_loading ? <Loader /> : null }
            {!this.state.listing_loading && !this.state.Show_list ?
                this.reportTableJsx() : ""}
           
        </div>)
    }

    reportTableJsx                          = () => {

        return (<Ax>
            <table className="table table-bordered bg-white align-items-center  table-sm table-hover  mb-0" id="rowDataReportTable">
                <thead className="align-middle table-secondary" style={{
                                    top: `${this.state.criteriaHeight}px`,
                                    position: 'sticky',
                                }}>
                    <tr>
                        <th scope="col" style={{ width: "20%" }}>Asset Name</th>
                        <th scope="col" style={{ width: "20%" }}>Service Checksheet Name</th>
                        <th scope="col" style={{ width: "19%" }}>Linked Items</th>
                        <th scope="col" style={{ width: "16%" }} className="text-start">Last CS Done</th>
                        <th scope="col" style={{ width: "10%" }}>Running Status</th>
                        <th scope="col" style={{ width: "8%" }} className="text-center">Due Date </th>
                        <th scope="col" style={{ width: "5%" }} className="text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.listing_loading ? (<tr><td className="text-center" colSpan={8}><Loader /></td></tr>)
                        : this.state.listingData && this.state.listingData.length > 0
                            ? (<Ax> {this.state.listingData.map((rowData, k) => {
                                let item_ids = [];
                                if (this.state.linked_items && this.state.linked_items.length > 0) {
                                    item_ids = this.state.linked_items.filter(li => li.scs_setting_id == rowData.id).map((item, index) => {
                                        return (item.items?.length > 0 ? item.items.map((i, itemKey) => { return (i.item_id) }) : [])
                                    })
                                }
                                let item_all_ids = item_ids.flat()
                                return (
                                    <tr key={k}>
                                        <td>{rowData.asset ?
                                            <div>
                                                <Link target="_blank" to={{ pathname: `/assets/service_checksheet/${rowData?.asset_id}` }}> {rowData.asset.name}</Link><br />
                                                <small>
                                                    Code :  {rowData.asset.asset_code ?? "-"} <br />
                                                    Asset Type :  {rowData.asset.asset_type_name ?? "-"}<br />
                                                    Site :  {rowData.asset.site ?? "-"}
                                                </small>
                                            </div> : '-'}</td>
                                        <td><b><a role="button" className="link-primary " onClick={() => this.runningStatusModalInit(rowData.id)}>{rowData.alias_name ? rowData.alias_name : "-"}</a></b></td>
                                        <td>
                                            {this.state.linked_items && this.state.linked_items.length > 0
                                                ? this.state.linked_items.filter(li => li.scs_setting_id == rowData.id).map((item, index) => {

                                                    return <Ax>{item.items?.length > 0 ? item.items.map((i, itemKey) => <div className='mt-1 link-primary cursor_pointer' onClick={() => this.viewItemModalInit(i.item, i.qty)}>{itemKey + 1}.{i.item.name} : {i.qty} {i.item && i.item.measuring_unit ? i.item.measuring_unit.name : ''} <br /><small className='form-text mt-1'> (Code : {i.item?.item_code})</small></div>) : " -"}<br /></Ax>

                                                })
                                                : "-"}
                                        </td>
                                        <td className="text-start"> {rowData.latest_execution_cl && rowData.latest_execution_cl.length > 0 ? rowData.latest_execution_cl.map((item, index) => { return (<div className="mt-1"> {item.label} : {item.reading}  {item.unit} <br /></div>) })
                                            : "-"}</td>
                                        <td className='text-center'>
                                            {rowData.latest_execution_id ?
                                                <div>
                                                    <div className="progress">
                                                        <div className="progress-bar progress-bar-striped" role="progressbar" style={{ width: `${rowData.max_running}%`, backgroundColor: `${rowData.bar_bg_color}` }}
                                                            aria-valuemin="0" aria-valuemax="100">
                                                        </div>
                                                    </div>
                                                    <small className='form-text'>{rowData.max_running}%</small>
                                                </div>
                                                : <span>NYA <sup>#</sup></span>}

                                        </td>
                                        <td className='text-center'>{rowData.expected_due_date ? rowData.expected_due_date : "-"}</td>
                                        <td className="text-center">
                                            <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn">
                                                <tapIcon.FontAwesomeIcon icon={tapIcon.faEllipsisV} />
                                            </button>
                                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                <li><a className="dropdown-item" role="button" onClick={() => this.runningStatusModalInit(rowData.id)}>View</a></li>
                                                <li><a className="dropdown-item" role="button" onClick={() => this.viewLinkedItemInit(rowData.id, rowData.alias_name)}>View Linked Items</a></li>
                                                <li><a className={item_all_ids && item_all_ids.length == 0 ? "dropdown-item disabled" : "dropdown-item "} disabled={item_all_ids && item_all_ids.length == 0 ? true : false} role="button" onClick={() => this.viewItemConumptionHistoryInit(rowData.id,rowData.asset_id)}>View Item Consumption History</a></li>
                                                <li> <Link className="dropdown-item" target="_blank" to={{ pathname: `/assets/execution_history/${rowData?.asset_id}`, search: "?" + new URLSearchParams({ search_scs_name: rowData.name ? rowData.name : rowData.alias_name }).toString() }}>History</Link></li>
                                                {/* <li><a className="dropdown-item" role="button" onClick={() => this.executeSingleModalInit(rowData.id, rowData.name)}>Execute</a></li> */}
                                            </ul>
                                        </td>
                                    </tr>)
                            })
                            }</Ax>)
                            : (<tr><td className="text-center" colSpan={8}>No Record Found</td></tr>)
                    }
                </tbody>
            </table>
        </Ax>);
    }

    render = () => {

        return (<ApplicationLayout>
            <Helmet> <title>Service Checksheet Running Status - Report</title></Helmet>
            {this.pageTitleBarJsx()}
            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div id="pageTbl" className="pageTbl col-12 pb-2">
                        {!this.state.listing_loading && this.state.time && <div style={{ backgroundColor: "white" }} className='px-3 py-1 text-end'>
                            <small className='form-text '>Report is based on Service Checksheet Data at ( {this.state.time} )</small>
                        </div>}

                        {this.state.formDataLoaded
                            ? (<Ax>
                                {this.reportFilterFormJsx()}
                                 <div ref={this.criteriaRef}
                                    style={{
                                        position: 'sticky',
                                        top: 0,
                                        background: 'white',
                                    }}>
                                <DisplaySearchCriteria searchedElems={this.state.formSearchedElems} />
                                </div>
                                {this.reportListingDisplayJsx()}
                            </Ax>)
                            : <Loader />
                        }
                        {this.state.listingMeta
                            ? <DisplayListPagination meta={this.state.listingMeta} onPageChange={(e) => this.loadListingTblData(e.selected + 1)} />
                            : null
                        }
                    </div>
                </div>
            </div>
            {/* {this.executeCounterlogModalJsx()} */}
            <RunningStatusViewModal parentProps={this.props} ref={this.RunningStatusModalRef} />
            <LinkedItemsViewModal parentProps={this.props} ref={this.LinkedItemsViewModalRef} />
            <ItemDetailsModal ref={this.itemDetailsRef} />
            <ItemsConsumptionHistory ref={this.itemsConsumptionHistoryRef} />
            <CounterlogExecutionModal
                ref={this.counterlogExecutionRef}
                afterExecutionSubmit={(id) => this.refreshSingleSCSRow(id)}
            />
        </ApplicationLayout>);
    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token,
        all_warehouses: state.app && state.app.warehouses ? state.app.warehouses : [],
        item_tags: state.app && state.app.item_tags ? state.app.item_tags : [],
        iam_asset_types: state.app && state.app.asset_type ? state.app.asset_type : [],
        iam_user_sites: state.app && state.app.user_sites ? state.app.user_sites : [],
        site_groups: state.app && state.app.site_groups ? state.app.site_groups : [],
        asset_groups: state.app && state.app.asset_groups ? state.app.asset_groups : [],
        report_listing: state.app && state.app.report_listing && state.app.report_listing.length > 0 ? state.app.report_listing : []
    };
};

export default connect(mapStateToProps)(ServiceChecksheetRunningStatus);